// PartA6OnlineCourses.js - Page 1: Plan to do Online Courses
import React from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

const PartA6OnlineCourses = ({ formData, handleInputChange }) => {
    // Course data matching the network diagram from the image
    const courseData = [
        { key: 'course_public_speaking', label: 'Public Speaking and Storytelling', color: '#4a90e2' },
        { key: 'course_formal_creative_writing', label: 'The Art of Formal and Creative Writing', color: '#2c3e50' },
        { key: 'course_health_nutrition_literacy', label: 'Health and Nutrition Literacy', color: '#3498db' },
        { key: 'course_environmental_sustainability', label: 'Environmental Sustainability', color: '#f39c12' },
        { key: 'course_citizen_politics_democracy', label: 'Citizen Politics in Democracy', color: '#8bc34a' },
        { key: 'course_mental_wellness', label: 'Mental Wellness', color: '#3498db' },
        { key: 'course_gender_sensitivity', label: 'Gender Sensitivity', color: '#e74c3c' },
        { key: 'course_citizenship_values', label: 'Citizenship Values', color: '#2c3e50' },
        { key: 'course_ethics_reasoning', label: 'Ethics and Reasoning', color: '#2c3e50' },
        { key: 'course_values_ethics_duties', label: 'Values, Ethics & Fundamental Duties', color: '#8bc34a' },
        { key: 'course_fundamentals_neuroscience', label: 'Fundamentals of Neuroscience', color: '#3498db' },
        { key: 'course_artistic_literacy', label: 'Artistic Literacy', color: '#e74c3c' },
        { key: 'course_coding', label: 'Coding', color: '#3498db' },
        { key: 'course_digital_marketing', label: 'Digital Marketing', color: '#2c3e50' },
        { key: 'course_computational_thinking', label: 'Computational Thinking', color: '#f39c12' },
        { key: 'course_entrepreneurship', label: 'Entrepreneurship', color: '#e74c3c' }
    ];

    const handleCourseToggle = (courseKey) => {
        handleInputChange(courseKey, !formData[courseKey]);
    };

    return (
        <div className="a4-page font-[poppins] bg-white p-8 mx-auto text-[#333333]" style={{ maxWidth: '100%', width: '100%' }}>
            {/* Header */}
            <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-[#F97316] mb-1">PART A (6)</h2>
                <h3 className="text-lg font-bold text-black">Plan to do Online Courses</h3>
            </div>

            {/* Introduction Text */}
            <div className="mb-6 text-sm leading-relaxed text-justify">
                <p className="mb-2">
                    As part of your upskilling at this stage of school education, you are encouraged to do online
                    courses and tutorials that help you develop different competencies. Given below is a list of
                    possible areas you could do some research on before choosing courses that will be of interest.
                </p>
                <p>
                    At the beginning of the year, start planning courses you would like to do over the course of the year.
                </p>
            </div>

            {/* Warning Box */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-center gap-3 mb-8">
                <div className="text-2xl">⚠️</div>
                <div className="text-sm text-yellow-800">
                    <strong>Be sure to check with your teacher about which courses are suitable.</strong>
                </div>
            </div>

            {/* Course Network */}
            <div className="mb-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <div className="flex flex-wrap gap-4 justify-center">
                    {courseData.map((course) => (
                        <div
                            key={course.key}
                            className={`
                                relative p-3 rounded-lg border-2 cursor-pointer transition-all duration-200
                                flex items-center gap-2 min-w-[200px] max-w-[250px]
                                ${formData[course.key] ? 'shadow-md transform scale-105' : 'hover:shadow-sm hover:scale-102'}
                            `}
                            style={{
                                backgroundColor: formData[course.key] ? course.color : 'white',
                                borderColor: course.color,
                                color: formData[course.key] ? 'white' : course.color
                            }}
                            onClick={() => handleCourseToggle(course.key)}
                        >
                            <div className={`
                                w-6 h-6 rounded-full border-2 flex items-center justify-center text-sm font-bold
                                ${formData[course.key] ? 'border-white bg-white/20' : 'border-current'}
                            `}>
                                {formData[course.key] && <span>✓</span>}
                            </div>
                            <div className="text-sm font-bold leading-tight">{course.label}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Planning Notes */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                    <label className="block font-bold text-blue-900 mb-2">Course Planning Notes:</label>
                    <TextArea
                        value={formData.course_planning_notes}
                        onChange={(e) => handleInputChange('course_planning_notes', e.target.value)}
                        placeholder="Add your notes about course planning and timeline..."
                        rows={6}
                        className="bg-white border-blue-200 focus:border-blue-400"
                    />
                </div>

                <div className="bg-green-50 p-4 rounded-lg border border-green-100">
                    <label className="block font-bold text-green-900 mb-2">Teacher Consultation Notes:</label>
                    <TextArea
                        value={formData.teacher_consultation_notes}
                        onChange={(e) => handleInputChange('teacher_consultation_notes', e.target.value)}
                        placeholder="Notes from discussions with your teacher about suitable courses..."
                        rows={6}
                        className="bg-white border-green-200 focus:border-green-400"
                    />
                </div>
            </div>
        </div>
    );
};

export default PartA6OnlineCourses;